import $ from 'jquery';

class HeaderScroll  {

	constructor(currentStatus) {
		// console.log('HeaderScroll constructor');
		this.isAnchor = false;

		this.checkIfAnchor();
		setTimeout(() => {
			this.detectScroll();
		}, 400);	

        // toggle header hover state
        $('.header').on('mouseenter',function(){
            if (document.body.clientWidth > 892) {
                $(this).addClass('header--hovered');
            }
        }).on('mouseleave',function(){
            $(this).removeClass('header--hovered');
        });

        // expand/collapse mobile submenus
        $('.navigation__mobile .navigation__item i').on('click',function(){
            $(this).closest('.navigation__item').find('> .submenu').slideToggle();
            $(this).parent().toggleClass('open');
        });
        $('.navigation__mobile .navigation__link[href="#"]').on('click',function(e){
            e.preventDefault();
            $(this).parent().find('> i').trigger('click');
        })
	}

	checkIfAnchor() {
		var hash = window.location.hash;

        if( hash ) {

            var urlHash = hash.substring(1);

            if( urlHash == 'portfolio' ) {
            	this.isAnchor = true;
            }
            setTimeout(() => {
                this.isAnchor = false;
            }, 2000);
        }
	}

	detectScroll() {
		var lastScrollTop = 0;

		$(window).scroll(function(event){
			var scrollToTop = $(this).scrollTop();

			if( scrollToTop > 100 && !this.isAnchor ) {
				if (scrollToTop > lastScrollTop){

					$('.header').addClass('header--scrolled');
                    $('.header__search__results').slideUp(function(){
                        $(this).stop();
                        $(this).attr('style','display:none');
                    });

				} else {

					$('.header').removeClass('header--scrolled');
                    if ($('.header__search input').eq(0).val() != '') {
                        $('.header__search__results').slideDown(function(){
                            $(this).stop();
                            $(this).attr('style','display:block');
                        });
                    }

				}
				lastScrollTop = scrollToTop;
			}	
		});

	}

}



module.exports = HeaderScroll;